import { useEffect, useContext } from "react";
import UserContext from "../Context/User/userContext";
import { useNavigate, useLocation } from "react-router-dom";
import axios from "axios";

const Protected = ({ Component, setShowSpinner }) => {
    const { user, setUser } = useContext(UserContext);
    const localUser = localStorage.getItem('user')
    const navigate = useNavigate()
    const location = useLocation()
    useEffect(() => {
        if (!user || !localUser) {
            navigate("/")
        } else {
            //Bearer Token
            const token = localStorage.getItem('token');
            const tokenValue = token ? token.slice(1, token.length - 1) : "";
            const _id = typeof localUser === 'string' ? JSON.parse(localUser)._id : localUser._id;
            axios.get(`https://research-mate-b35a10757d5a.herokuapp.com/api/auth/validateAdmin/${_id}`, {
                headers: {
                    'Authorization': `Bearer ${tokenValue}`
                    // You can add other headers if needed like authorization token, etc.
                }
            })
                .then(res => {
                    const adminExist = res.data.success;
                    if (!adminExist) {
                        axios.get(`https://research-mate-b35a10757d5a.herokuapp.com/api/auth/user?id=${_id}`, {
                            headers: {
                                'Authorization': `Bearer ${tokenValue}`
                                // You can add other headers if needed like authorization token, etc.
                            }
                        })
                            .then(res => {
                                // Handle success
                                if (!res.data.user.approvedByAdmin && location.pathname !== '/authentication') {
                                    navigate("/authentication")
                                } else if (res.data.user.approvedByAdmin &&
                                    (
                                        location.pathname == '/createStudy' ||
                                        location.pathname == '/developingStudy' ||
                                        location.pathname == '/closeStudy' ||
                                        location.pathname == '/sites' ||
                                        location.pathname == '/sponsorStudy'
                                    )
                                ) {
                                    console.log(location.pathname)
                                    navigate("/home");
                                }
                            })
                            .catch(error => {
                                console.error("Error:", error.response.data.message);
                            });
                    }
                })
                .catch(error => {
                    console.error("Error:", error.response.data.message);
                });

        }
    }, [user, navigate])
    return (
        <div>
            <Component setShowSpinner={setShowSpinner} />
        </div>
    )
}

export default Protected;